import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import useStyles from './styles/index.styles';

const VideoPopup = ({ isOpen, videoUrl, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} className={classes.videoDialog} maxWidth={false} fullWidth>
      <DialogContent>
        <Box>
          <Box className={classes.iframeWrapper}>
            {videoUrl ? (
              <iframe
                title="media"
                style={{ display: 'block', background: 'none', border: 'none' }}
                src={videoUrl}
              />
            ) : null}
          </Box>
          {videoUrl ? (
            <Box mt={1}>
              <Button
                size="small"
                color="primary"
                component="a"
                href={videoUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open in new tab
              </Button>
            </Box>
          ) : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <Box>
          <Button onClick={onClose} style={{ color: '#fff' }}>
            Close
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

VideoPopup.propTypes = {
   isOpen: PropTypes.bool,
   videoUrl: PropTypes.string,
   onClose: PropTypes.func,
};

VideoPopup.defaultProps = {
   isOpen: false,
   videoUrl: '',
   onClose: null,
};

export default VideoPopup;